"use client"

import * as React from "react"

import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card"

interface Calendar10Props {
  selected?: Date;
  onSelect?: (date: Date | undefined) => void;
  disabled?: (date: Date) => boolean;
}

export default function Calendar10({ selected, onSelect, disabled }: Calendar10Props) {
  const [month, setMonth] = React.useState<Date | undefined>(selected || new Date())



  return (
    <Card className="bg-transparent border-none shadow-none">
      <CardHeader className="relative bg-transparent p-1 pb-0">
      </CardHeader>
      <CardContent className="bg-transparent p-0 pt-0">
        <Calendar
          mode="single"
          month={month}
          onMonthChange={setMonth}
          selected={selected}
          onSelect={onSelect}
          disabled={disabled}
          weekStartsOn={1}
          className="bg-transparent p-0 text-white w-full [&_.rdp-table]:w-full [&_.rdp-head_cell]:text-gray-300 [&_.rdp-button]:text-white [&_.rdp-button:hover]:bg-white/10 [&_.rdp-button]:w-7 [&_.rdp-button]:h-6 [&_.rdp-head_cell]:w-7 [&_.rdp-head_cell]:text-center [&_.rdp-head_cell]:text-xs [&_.rdp-head_cell]:py-1 [&_.rdp-cell]:p-0 [&_.rdp-button]:text-xs [&_.rdp-nav_button]:w-6 [&_.rdp-nav_button]:h-6 [&_.rdp-nav_button]:text-xs [&_.rdp-caption]:mb-1 [&_.rdp-head]:mb-0 [&_.rdp-tbody]:space-y-0 [&_tr]:space-y-0"
        />
      </CardContent>
    </Card>
  )
}
